module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/building-trust.json
// module id = 341
// module chunks = 15897754074539